import { api, handleApiCall, ApiResult } from './api';
import { StockImportResultDto } from '../types/stocks';

export const investmentsImportExportApi = {
  downloadTemplate: async (): Promise<Blob> => {
    const response = await api.get('/api/stock-import-export/template', {
      responseType: 'blob',
    });
    return response.data as Blob;
  },

  exportAll: async (): Promise<Blob> => {
    const response = await api.post('/api/stock-import-export/export', null, {
      responseType: 'blob',
    });
    return response.data as Blob;
  },

  importAll: async (file: File, clearExisting: boolean): Promise<StockImportResultDto> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('clearExisting', String(clearExisting));
    return handleApiCall(() =>
      api.post<ApiResult<StockImportResultDto>>('/api/stock-import-export/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    );
  },
};
